/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Backtologin2Inputs */

const en_backtologin2 = /** @type {(inputs: Backtologin2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to login`)
};

const de_backtologin2 = /** @type {(inputs: Backtologin2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zur Anmeldung`)
};

/**
* | output |
* | --- |
* | "Back to login" |
*
* @param {Backtologin2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const backtologin2 = /** @type {((inputs?: Backtologin2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Backtologin2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_backtologin2(inputs)
	return de_backtologin2(inputs)
});
export { backtologin2 as "backToLogin" }